import { render, staticRenderFns } from "./departments.vue?vue&type=template&id=3e96e5d1"
import script from "./departments.vue?vue&type=script&lang=js"
export * from "./departments.vue?vue&type=script&lang=js"
import style0 from "./departments.vue?vue&type=style&index=0&id=3e96e5d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports